import React, { createContext, useContext, useState, useEffect } from 'react';
import secureStorage from '../config/encrypt';

type Translations = Record<string, any>;

interface LanguageContextProps {
  language: string;
  translations: Translations;
  setLanguage: (lang: string) => void;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [translations, setTranslations] = useState<Translations>({});

  const loadTranslations = async (lang: string) => {
    const data = await import(`../lang/${lang}.json`);
    setTranslations(data);
    secureStorage.setItem('lang', lang);
  };

  useEffect(() => {
    loadTranslations(language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, translations, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
